<!--Create Fleet User Title-->
<h2>Create Fleet User</h2>
<p>Customer ID: {{customerId}}</p>
<mat-dialog-content>
    <!--Dialog Content-->
    <div *ngIf="!createFleetUserResponse">
        <form novalidate>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>User Email</mat-label>
                    <input type="email" required aria-required="true" matInput [(ngModel)]="userEmail" [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="form-field">
                    <mat-label>Fleet Kind</mat-label>
                    <mat-select required aria-required="true" [(ngModel)]="createFleetUserRequest.fleetKind" [ngModelOptions]="{standalone: true}">
                        <mat-option *ngFor="let item of createFleetUserDialogData.fleetKindList" [value]="item">
                            <span>{{item}}</span>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <section>
                    <mat-checkbox [(ngModel)]="createFleetUserRequest.isEnabled"
                        [ngModelOptions]="{standalone: true}">Enabled</mat-checkbox>
                </section>
            </div>            
        </form>
    </div>
    <div *ngIf="createFleetUserResponse">
        <label>User Id: {{createFleetUserResponse.fleetUser?.userId}}</label> <br />
        <button mat-raised-button (click)="close()">Ok</button>
    </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!createFleetUserResponse">
    <!--Dialog action buttons-->
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving">
        <span *ngIf="!isSaving">Save</span>
        <span *ngIf="isSaving">Saving...</span>
    </button>
    <button mat-raised-button [disabled]="isSaving" (click)="close()">Cancel</button>
</mat-dialog-actions>